export class ColumnSettingsBase {
    constructor(
        public readonly id: number,
        public readonly columnName: string,
        public readonly filterType: string,
        public readonly formatter: string,
        public translateKey: string,
        public readonly type: string,
        public readonly visibility: number,
        public readonly width: number,
        public readonly position: number,
        public edit?: string,
        public readonly excelCellBlock?: boolean,
        public readonly group?: string,
        public readonly descriptionVisibility?: number,
        public readonly descriptionKey?: string,
        public grouping?: number,
        public readonly aggregation?: number,
        public tooltip?: string,
        public disabled?: boolean,
        ) {

        this.denyDisable = false;
    }

    public denyDisable: boolean;
}

export class WebTableSettings {
    constructor(
        public readonly moduleName: string,
        public readonly tableName: string,
        public readonly columns: ColumnSettingsBase[]
    ) {
    }
}


export class StocksColumnSettingsBase {
    constructor(
        public readonly id: number,
        public readonly columnName,
        public readonly filterType,
        public readonly formatter,
        public translateKey,
        public readonly type,
        public readonly visibility,
        public readonly descriptionVisibility,
        public readonly descriptionKey,
        public readonly group
    ) {
        this.hidden = false;
    }

    public hidden: boolean;
}



// WEBPACK FOOTER //
// ./src/app/slick-grid/models/column-settings-base.ts